"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SLUG_OWNER = void 0;
exports.SLUG_OWNER = {
    STORE: 'STORE',
    LANDING: 'LANDING',
    PRODUCT: 'PRODUCT'
};
//# sourceMappingURL=slugOwner.js.map